<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <h6 class="text-muted text-uppercase small mb-2">Work Alone Approval</h6>
        <p class="small text-muted">Items marked with <span class="text-danger">*</span> require a response.</p>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="employeeHrRef">Name of Employee <span class="text-danger">*</span></label>
                    <wj-combo-box
                        [(ngModel)]="target.employeeHrRef"
                        name="employeeHrRef"
                        id="employeeHrRef"
                        [itemsSource]="employeeList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="true"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="workDate">Date</label>
                    <wj-input-date [(ngModel)]="target.workDate" name="workDate" id="workDate" [isRequired]="false"></wj-input-date>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="siteLocation">Site Location</label>
                    <app-voice-text-field
                        [(ngModel)]="target.siteLocation"
                        name="siteLocation"
                        inputId="siteLocation"
                        [rows]="2"
                        [showLocationButton]="true"
                    ></app-voice-text-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="jobDescription">Job Description (Duties)</label>
                    <app-voice-text-field
                        [(ngModel)]="target.jobDescription"
                        name="jobDescription"
                        inputId="jobDescription"
                        [rows]="3"
                    ></app-voice-text-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-check mt-4">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="weekendWork"
                        name="weekendWork"
                        [(ngModel)]="target.weekendWork"
                    />
                    <label class="form-check-label" for="weekendWork">Will the work be done on a weekend?</label>
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="lengthOfTime">Length of Time Needed</label>
                    <input
                        type="text"
                        class="form-control"
                        id="lengthOfTime"
                        name="lengthOfTime"
                        [(ngModel)]="target.lengthOfTime"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 col-12">
                <div class="form-group">
                    <label for="emergencyContact1">Emergency contact 1st</label>
                    <input
                        type="text"
                        class="form-control"
                        id="emergencyContact1"
                        name="emergencyContact1"
                        [(ngModel)]="target.emergencyContact1"
                    />
                </div>
            </div>
            <div class="col-md-4 col-12">
                <div class="form-group">
                    <label for="emergencyContact2">Emergency contact 2nd</label>
                    <input
                        type="text"
                        class="form-control"
                        id="emergencyContact2"
                        name="emergencyContact2"
                        [(ngModel)]="target.emergencyContact2"
                    />
                </div>
            </div>
            <div class="col-md-4 col-12">
                <div class="form-group">
                    <label for="emergencyContact3">Emergency contact 3rd</label>
                    <input
                        type="text"
                        class="form-control"
                        id="emergencyContact3"
                        name="emergencyContact3"
                        [(ngModel)]="target.emergencyContact3"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="communicationMethod">Communication is?</label>
                    <wj-combo-box
                        [(ngModel)]="target.communicationMethod"
                        name="communicationMethod"
                        id="communicationMethod"
                        [itemsSource]="communicationMethodList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                        [isEditable]="false"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="employeeSignature">Employee Signature</label>
                    <input
                        type="text"
                        class="form-control"
                        id="employeeSignature"
                        name="employeeSignature"
                        [(ngModel)]="target.employeeSignature"
                    />
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="signedOn">Signed On</label>
                    <wj-input-date-time [(ngModel)]="target.signedOn" name="signedOn" id="signedOn" [isRequired]="false"></wj-input-date-time>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-check mb-2">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="supervisorNotified"
                        name="supervisorNotified"
                        [(ngModel)]="target.supervisorNotified"
                    />
                    <label class="form-check-label" for="supervisorNotified">
                        Supervisor is aware of work alone duties (a text message was sent)
                    </label>
                </div>
                <div class="form-check mb-2">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="safetyManagerNotified"
                        name="safetyManagerNotified"
                        [(ngModel)]="target.safetyManagerNotified"
                    />
                    <label class="form-check-label" for="safetyManagerNotified">
                        Safety Manager is aware of work alone permit (a text message was sent)
                    </label>
                </div>
                <p class="small text-muted mb-0">These checkboxes record acknowledgement only. WebApps does not send the text message.</p>
            </div>
        </div>

        @if (target.imageUrls && target.imageUrls.length > 0) {
            <div class="row">
                <label>Attachments</label>
                @for (url of target.imageUrls; let i = $index; track i + '|' + url) {
                    <div class="col-sm-6 col-6" style="margin-bottom: 10px">
                        <img
                            style="max-width: 250px; cursor: pointer"
                            [src]="getExistingFileSrc(url)"
                            (click)="openExistingFile(url)"
                            alt=""
                        />
                        <div class="small text-muted mt-1">{{ displayFileName(i) }}</div>
                    </div>
                }
            </div>
        }
        @if (attachments && attachments.length > 0) {
            <div class="row">
                <label>Files To Upload</label>
                @for (file of attachments; track file) {
                    <div class="col-sm-6 col-6" style="margin-bottom: 10px">
                        <div class="close-x" (click)="removeAttachment(file)">
                            <fa-icon [icon]="faX"></fa-icon>
                        </div>
                        <img style="width: 100%" [src]="getPendingFileSrc(file)" />
                        <div class="small text-muted mt-1">{{ file.name }}</div>
                    </div>
                }
            </div>
        }
        @if (progress > 0 && progress < 100) {
            <div class="row">
                <div class="col-12">
                    <div class="progress">
                        <div
                            class="progress-bar"
                            role="progressbar"
                            [ngStyle]="{ 'width.%': progress }"
                            aria-valuenow="25"
                            aria-valuemin="0"
                            aria-valuemax="100"
                        >
                            {{ progress }}%
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" style="margin-right: auto" (click)="fileInput.click()">Upload Photos / Documents</button>
        <input
            style="display: none"
            type="file"
            (change)="onFileChanged($event)"
            accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.txt"
            #fileInput
            multiple
        />
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
